/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, ContractFactory, Interface, } from "ethers";
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "allowance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "ERC20InsufficientAllowance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "balance",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "needed",
                type: "uint256",
            },
        ],
        name: "ERC20InsufficientBalance",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "approver",
                type: "address",
            },
        ],
        name: "ERC20InvalidApprover",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
        ],
        name: "ERC20InvalidReceiver",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "ERC20InvalidSender",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "ERC20InvalidSpender",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "OwnableInvalidOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "OwnableUnauthorizedAccount",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class ExampleERC20Token__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new Interface(_abi);
    }
    static connect(address, runner) {
        return new Contract(address, _abi, runner);
    }
}
ExampleERC20Token__factory.bytecode = _bytecode;
ExampleERC20Token__factory.abi = _abi;
//# sourceMappingURL=ExampleERC20Token__factory.js.map